import { ReactNode, useContext, useEffect } from 'react';
import { ModalsKeys, TabsOption } from 'global';
import { useDispatch } from 'react-redux';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { IntegrationSettingsDialog } from 'modules/integrationSettings';
import { aftermarketPartnerActions } from 'modules/aftermarketPartner/model';
import { AddDealerDialog } from '../../dialogs/AddDealerDialog';
import { DealerManagementCard } from '../../components/dealerManagementCard/DealerManagementCard';
import { DealerManagementTabs } from 'modules/aftermarketPartner/types';
import { BroadcastsTable } from 'modules/broadcasts';
import { CardBackground } from 'components/CardBackground/CardBackground';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { CommonDataContext } from 'contexts/CommonDataContext';

const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.AftermarketPartnerAddDealerDialog]: <AddDealerDialog />,
  [ModalsKeys.IntegrationSettingsDialog]: <IntegrationSettingsDialog />,
};

export const DealerManagementPage = () => {
  const dispatch = useDispatch();

  const { isSuperAdminOrSingleAccount } = useContext(CommonDataContext);

  const tabs: TabsOption<DealerManagementTabs>[] = [
    {
      label: 'Dealer Management',
      value: DealerManagementTabs.DealerManagement,
      component: <DealerManagementCard />,
      urlAnchor: `#${DealerManagementTabs.DealerManagement}`,
      isVisible: true,
    },
    {
      label: 'Broadcasts',
      value: DealerManagementTabs.Broadcasts,
      component: <BroadcastsTable />,
      urlAnchor: `#${DealerManagementTabs.Broadcasts}`,
      isVisible: isSuperAdminOrSingleAccount,
    },
  ];

  useEffect(
    () => () => {
      dispatch(aftermarketPartnerActions.clearState());
    },
    []
  );

  return (
    <PageContainer modals={modalsWithKeys}>
      <TabsContainer<DealerManagementTabs>
        tabs={tabs}
        TabsLabelWrapper={CardBackground}
        tabsWrapperProps={{ mb: 1 }}
        isSyncWithAnchor
      />
    </PageContainer>
  );
};
